export default __webpack_public_path__ + "1.18.25/static/media/libreView.eba75fec.svg";